import OfficeMapper from "../mappers/Office.mapper"
import axios from 'axios';
import Office from "../models/Office";

export default class OfficesService {
    public async getOffices(): Promise<Office[]> {
        let api = axios.create({
            baseURL: ''
        })
        const data : any = await api.get('/Offices/Get');
        
        const offices : Office[] = data.data.map((off: any) => {return new OfficeMapper().map(off)});
        return offices;
    }
}